import { Component, OnInit } from '@angular/core';
import { User } from '../../shared/user.model';
import { UserService } from '../../shared/user.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastrService } from 'ngx-toastr';
import { StoresService } from '../../shared/stores.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

  users: User[];
  constructor(
    private service:UserService,
    private serviceStore:StoresService,
    private firestore:AngularFirestore,
    private toastr : ToastrService) { }

  ngOnInit() {

    this.service.getUsers().subscribe(actionArray =>{
      this.users = actionArray.map(item => {
        const data = item.payload.doc.data() as User;
        const id = item.payload.doc.id;
        return { id, ...data };
      })
    });

  }

}
